import { useMutation } from "react-query";
import axios from "axios";
import Config from "../Config";

export const useLeaseDetails = (token) => {
  const fetchLeaseDetails = async (params) => {

    const response = await axios.get(
      // `${Config.apiUrl}/property/lease/details?propId=${params.propId}&flatId=${params.flatId}`,
      `${Config.apiUrl}/property/lease/details?propId=${params.propId}${params.flatId ? `&flatId=${params.flatId}` : ""
      }`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const onSuccess = (res) => {
    // if (res?.data === false) {
    //   console.error("No data found");
    // } else {
    //   setApiData(res?.data);
    //   setIsFocused(true);
    // }
  };

  const onError = (error) => {
    // console.error("Error fetching lease details:", error);
  };

  const mutation = useMutation(fetchLeaseDetails, {
    onSuccess,
    onError,
  });

  return mutation;
};

export const useUnpaidExpensesDetails = (token) => {
  const fetchUnpaidExpensesDetails = async (propId) => {
    const response = await axios.get(
      `${Config.apiUrl}/landlord/unpaid/expenses/list?propId=${propId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const onSuccess = (res) => { };

  const onError = (error) => {
    // console.error("Error fetching lease details:", error);
  };

  const mutation = useMutation(fetchUnpaidExpensesDetails, {
    onSuccess,
    onError,
  });

  return mutation;
};

/**
 * Edit landlord / lease details
 */
export const useEditLandlordLease = ({
  token,
  onSuccessCallback,
  onErrorCallback,
}) => {
  const editLandlordFunction = async (values) => {
    const response = await axios.post(
      `${Config.apiUrl}/property/lease/details/update`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  };

  return useMutation(editLandlordFunction, {
    onSuccess: (data) => {
      onSuccessCallback?.(data);
    },
    onError: (error) => {
      onErrorCallback?.(error);
    },
  });
};

/**
 * Save landlord payment details
 */
export const useSaveLandlordPayment = ({
  token,
  onSuccessCallback,
  onErrorCallback,
}) => {
  const savePaymentFn = async (data) => {
    const response = await axios.post(
      `${Config.apiUrl}/landlord/manage/paymentdetail`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  };

  return useMutation(savePaymentFn, {
    onSuccess: (res) => {
      onSuccessCallback?.(res);
    },
    onError: (error) => {
      onErrorCallback?.(error);
    },
  });
};

/**
 * Upload landlord documents
 */
export const useUploadLandlordDocument = ({
  token,
  onSuccessCallback,
  onErrorCallback,
}) => {
  const uploadDocumentFn = async (values) => {
    const response = await axios.post(
      `${Config.apiUrl}/client/landlord/docs/upload`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  return useMutation(uploadDocumentFn, {
    onSuccess: (res) => {
      onSuccessCallback?.(res);
    },
    onError: (error) => {
      onErrorCallback?.(error);
    },
  });
};
